import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

import { createRequestOption, ReconcileStatusResponse } from '@appshared';
import { map } from 'rxjs/operators';

@Injectable()
export class ReconcilesApiService {
  protected resourceUrl = 'sale-data-svc/api/reconcile';

  constructor(
    public _http: HttpClient,
  ) { }


  /**
   * API check reconcile info
   *
   * @param {*} [req]
   * @return {*}  {Observable<any>}
   * @memberof PaymentHistoryApiService
   */
  checkReconcileInfo(req?: any): Observable<ReconcileStatusResponse> {
    const options = createRequestOption(req);
    return this._http.get<ReconcileStatusResponse>(`${this.resourceUrl}/info`, { params: options })
      .pipe(map((res: ReconcileStatusResponse) => this.convertDateFromServer(res)));;
  }

  /**
   * API to reconcile the sales data
   *
   * @param {*} [req]
   * @return {*}  {Observable<any>}
   * @memberof PaymentHistoryApiService
   */
  reconcile(req?: any): Observable<ReconcileStatusResponse> {
    const options = createRequestOption(req);
    return this._http.patch<ReconcileStatusResponse>(`${this.resourceUrl}/`, { params: options });
  }

  protected convertDateFromServer(res: ReconcileStatusResponse): ReconcileStatusResponse {
    if (res) {
      res.lastSyncTime = res.lastSyncTime ? moment(res.lastSyncTime) : undefined;
      res.lastReconcileTime = res.lastReconcileTime ? moment(res.lastReconcileTime) : undefined;
    }
    return res;
  }
}
